/**
 * O `*` vermelho do campo obrigatório (13.15, chamado de 26/10/2026, item E: "os campos que são
 * obrigatórios devem aparecer com um * vermelho na frente"). **O lugar único**: toda ficha e todo
 * formulário que marca um obrigatório usa esta peça, e a cor (`--vermelho`, a exceção declarada no
 * `DESIGN.md`) mora só em `marca-de-obrigatorio.css`.
 *
 * - **Fora do `<label>`**, como irmão logo depois dele: dentro, o `*` entraria no nome acessível do
 *   campo ("Nome *") e quebraria cada consulta `getByLabelText('Nome')` da suíte. O leitor de tela
 *   não o lê (`aria-hidden`); quem diz "obrigatório" a ele é o `aria-required="true"` do controle.
 * - **Nada de `::after`**: o pseudo-elemento não aparece na árvore, e o teste não o enxergaria.
 * - `LinhaDoRotulo` põe o rótulo e o `*` na mesma linha ("Nome *"), dentro de um campo que empilha
 *   rótulo e controle em coluna. Sem `obrigatorio`, devolve o rótulo como veio — o campo opcional
 *   não muda de árvore.
 */

import type { ReactNode } from 'react'

import './marca-de-obrigatorio.css'

/** O texto do marcador — o que o teste procura ao lado do rótulo. */
export const MARCA_DE_OBRIGATORIO = '*'

export function MarcaDeObrigatorio() {
  return (
    <span className="marca-de-obrigatorio" aria-hidden="true" data-obrigatorio="sim">
      {MARCA_DE_OBRIGATORIO}
    </span>
  )
}

/** O rótulo e, quando o campo é obrigatório, o `*` logo depois dele, na mesma linha. */
export function LinhaDoRotulo({
  obrigatorio,
  children,
}: {
  obrigatorio: boolean
  /** O `<label>` do campo. */
  children: ReactNode
}) {
  if (!obrigatorio) {
    return <>{children}</>
  }
  return (
    <span className="linha-do-rotulo">
      {children}
      <MarcaDeObrigatorio />
    </span>
  )
}
